import { getAllUsers } from '@juno/client-api';
import { CommunityUser, RoleEnum } from '@juno/client-api/model';
import { calculateUserSearchFilters } from '@juno/utils';

export const mentions_fetch = async (
  query: any,
  success: any,
  getImageSrc: any,
  platformId: string,
) => {
  // TODO - do we want this to only search group members
  const filter = calculateUserSearchFilters(query.term.toLowerCase());
  const allUsers = await getAllUsers(platformId, {
    ...filter,
    filter: {
      active: true,
    },
    exclude: {
      role: RoleEnum.NUMBER_2,
    },
    order: 'first_name',
    limit: 10,
  });
  const tinyUsers = convertTinyMceUsers(allUsers, getImageSrc ?? (() => ''));
  success(tinyUsers);
};

export const createTinyMceMentionSpan = (editor: any, user: CommunityUser): HTMLSpanElement => {
  // unfortunately raw html is the only way that you can add a mention to the editor :(
  const span = editor.getDoc().createElement('span');
  span.className = 'user_mention';
  span.setAttribute('aria-label', 'View user details');
  span.setAttribute('data-mention-id', user.id);
  span.appendChild(editor.getDoc().createTextNode(`@${user.first_name} ${user.last_name}`));
  return span;
};

export const convertTinyMceUsers = (users: CommunityUser[], imageSrcFn: any): CommunityUser[] => {
  return users.map((u) => ({
    id: u.id,
    first_name: u.first_name,
    last_name: u.last_name,
    name: u.first_name && u.last_name ? `${u.first_name} ${u.last_name}` : u.email,
    email: u.email,
    image:
      u.avatar ||
      u.icon ||
      'https://cdn.junolive.co/assets/ui/tinymce_assets/default_person_icon.png',
  }));
};
